<script lang="ts" setup>
	defineProps<{
		text?: string | HTMLElement
		src?: string
	}>()
</script>
<template>
	<div
		class="item-center flex h-[40px] w-[40px] justify-center overflow-hidden rounded-full bg-[#FDDCAB] font-semibold leading-[40px]"
	>
		<img v-if="!text && src" :src="src" alt="Dummy image" />
		<span v-if="text && !src" class="text-[11.2px] uppercase tracking-tight text-blue-950" v-html="text" />
	</div>
</template>
